import { AuthPrompt, GUEST_USERNAME_REGEX, TENANT_DOMAIN_IGNORE_LIST, TENANT_DOMAIN_REGEX } from '../constants';
/**
 * Get a normalized username based on whether this is a guest user or not
 * @param username
 */
export function getNormalUsername(username) {
    const match = username?.match(GUEST_USERNAME_REGEX);
    // return the orignal value if username doesn't match guest username format
    if (match == null) {
        return username;
    }
    // return this instead if match guest username format
    const [, alias, domain] = match;
    return !domain ? alias : `${alias}@${domain}`;
}
/**
 * Return standard prompt value that is acceptable by the identify platform
 * @param prompt
 */
export function getNormalPromptQuery(prompt) {
    if (prompt == null) {
        return;
    }
    switch (prompt.toLowerCase()) {
        case 'select_account':
        case 'account':
            return AuthPrompt.SELECT_ACCOUNT;
        case 'login':
        case 'credentials':
            return AuthPrompt.LOGIN;
    }
}
/**
 * Deletes query params from the provided URL, case-insensitively and return the new URL
 * @param url
 * @param paramNamesToDelete
 */
export function deleteQueryParams(url, paramNamesToDelete) {
    const lowercaseParamNameSet = new Set(paramNamesToDelete.map((pn) => pn.toLowerCase()));
    const newUrl = new URL(url.toString());
    url.searchParams.forEach((_, paramName) => {
        if (lowercaseParamNameSet.has(paramName.toLowerCase())) {
            newUrl.searchParams.delete(paramName);
        }
    });
    return newUrl;
}
/**
 * Extract the value of the query param that matches any of the provided param names, case-insensitively.
 * @param url
 * @param paramNames
 */
export function getQueryParam(url, paramNames) {
    const lowercaseParamNameSet = new Set(paramNames.map((pn) => pn.toLowerCase()));
    // Search for the query param name case insensitively, but keep the casing of the value, if found
    let value;
    url.searchParams.forEach((paramValue, paramName) => {
        if (lowercaseParamNameSet.has(paramName.toLowerCase())) {
            value = value ?? paramValue;
        }
    });
    return value;
}
/**
 * Remove tenant domain from the URL pathname
 * @param oldUrl
 */
export function removeTenantDomainFromPath(oldUrl) {
    // e.g: https://myaccount.microsoft.com/@domainName#/somePath/?tenantId={tenantId}?upn={upn}#hash
    const fullUrl = oldUrl.href;
    // return /@domainName#/somePath/?tenantId={tenantId}?upn={upn}#hash
    const urlSuffix = fullUrl.substring(oldUrl.origin.length);
    // find pattern that matches TENANT_DOMAIN_REGEX
    const match = urlSuffix.match(TENANT_DOMAIN_REGEX);
    // capture the tenant domain name if match && not in ignore list
    const tenantDomain = match?.[1] && TENANT_DOMAIN_IGNORE_LIST.includes(match?.[1].toLowerCase()) ? undefined : match?.[1] ?? undefined;
    // capture the remaining path if there was a match above
    const remainingPath = match?.[2];
    let newUrl;
    if (match !== null) {
        if (remainingPath) {
            newUrl = new URL(remainingPath, oldUrl.origin);
        }
        else {
            newUrl = new URL('/', oldUrl.origin);
        }
    }
    return {
        tenantDomain,
        url: newUrl ?? oldUrl
    };
}
//# sourceMappingURL=helper.js.map